import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Magazine from "./Magazine";
import type Newspaper from "./Newspaper";
import type Podcast from "./Podcast";
import type RadioStation from "./RadioStation";
import type TvChannel from "./TvChannel";
import type User from "./User";
import type Website from "./Website";

enum Action {
  "create_media_request" = 0,
  "create_transcript_request" = 1,
  "other" = 2,
}

enum Status {
  "pending" = 0,
  "in_progress" = 1,
  "completed" = 2,
  "cancelled" = 3,
}

@Model()
class MentionExpectation extends ApplicationRecord {
  static jsonapiType = "mention_expectations";

  @Attr() action: Action;

  @Attr() comment: string;

  @Attr() contactNotes: string;

  @Attr() contentNotes: string;

  @Attr({ persist: false }) createdAt: string;

  @HasOne() handlingAccountManager: User;

  @Attr() handlingAccountManagerId: number;

  @Attr() keywords: string[];

  @Attr() recipients: string[];

  @HasOne() requestingAccountManager: User;

  @Attr() requestingAccountManagerId: number;

  @BelongsTo() source:
    | TvChannel
    | RadioStation
    | Website
    | Newspaper
    | Magazine
    | Podcast;

  @Attr() sourceId: string;

  @Attr() sourceName: string;

  @Attr() sourceType: string;

  @Attr() startTime: string;

  @Attr() status: Status;

  @Attr() targetType: string;

  @Attr() timeZone: string;

  @Attr() title: string;

  @Attr() transcriptRequestSource: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default MentionExpectation;
